import * as React from 'react';

export const DownloadIconV2: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='M12 15V3' />
			<path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
			<path d='m7 10 5 5 5-5' />
		</svg>
	);
};
